export { default } from './PrivacyPage';
